import { Injectable } from '@angular/core';
import { Drivers } from '@ionic/storage';
import { Storage } from '@ionic/storage-angular';
import { TUserLoggedInInfoWithFeatureSet } from './unified-login.types';

type TDatabases = {
  '[LOGGED_IN_USER]': TUserLoggedInInfoWithFeatureSet;
  '[LOGGED_IN_USER][NOTIFICATION_TOKEN]': string | null;
};

@Injectable({
  providedIn: 'root',
})
export class UnifiedLoginStorageService {
  #storage: Storage = new Storage({
    name: '__userDatabase',
    driverOrder: [Drivers.IndexedDB, Drivers.LocalStorage],
  });

  constructor(private storage: Storage) {}

  async init() {
    try {
      this.#storage = await this.storage.create();
      return true;
    } catch (e) {
      console.log('[STORAGE] Error Initalizing Unified Login Storage', e);
      return false;
    }
  }

  async get<T extends keyof TDatabases>(key: T): Promise<TDatabases[T]> {
    const storage = await this.#storage?.get(key);
    return storage;
  }

  async remove<T extends keyof TDatabases>(key: T): Promise<TDatabases[T]> {
    const storage = await this.#storage?.remove(key);
    return storage;
  }

  // Create and expose methods that users of this service can
  // call, for example:
  async set<T extends keyof TDatabases>(key: T, value: TDatabases[T]) {
    const storage = await this.#storage?.set(key, value);
    return storage;
  }
}
